import { render } from "./B2bPageGenrals.vue?vue&type=template&id=3e4a19b5&scoped=true&lang=pug"
import script from "./B2bPageGenrals.vue?vue&type=script&lang=js"
export * from "./B2bPageGenrals.vue?vue&type=script&lang=js"

import "./B2bPageGenrals.vue?vue&type=style&index=0&id=3e4a19b5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4a19b5"]])

export default __exports__